import { useNavigate, useParams } from 'react-router-dom';
import React from 'react';
import { useMutation, useQuery } from 'react-query';
import * as yup from 'yup';
import { useFormik } from 'formik';
import api from '../../../../../components/api';
import { yupErrorMsg } from '../../../../../components/atoms/const';
import clientByIdDummy from '../clientById.json';
import { UpdateClientData } from '../../../../../components/api/clients';

function useClientsAddPartner(formikClient?: any, clientPartnerId?: number | null) {
  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Get Initial Data
  * 1. param from url format : clients/partner/:clientId/:partnerId
  * 2. Need data about client detail by clientId, because there are still no API to only update
  * partnerCommision and partnerId. So, currently we'll use updateClient API.
  * 3. Partner List are also needed for getting partnerId for updating or creating new Partner
  */

  // 1. Get Params from url
  const { clientId, partnerId } = useParams();

  // navigation handler
  const navigation = useNavigate();
  const onNavigateToClientDetail = () => navigation(`/clients/${clientId}`);
  const onCancelNavigate = () => navigation(`/clients/${clientId}`);

  // 2. Get Client Detail By ClientId
  // Convert clientById data into updateClientData
  const { data: clientByIdRes } = useQuery(['getById', 'clients', clientId], () => api.clients.getById(clientId!), {
    enabled: !!clientId,
  });
  const clientById: UpdateClientData | undefined = React.useMemo(() => {
    const resData: typeof clientByIdDummy | undefined = clientByIdRes?.data?.data;
    if (resData) {
      return {
        id: resData.id,
        name: resData.name,
        addressChanged: false,
        categoryId: resData.categoryId,
        commision: resData.commission,
        partnerId: resData.partner.id,
        partnerCommission: resData.partner.comission,
      };
    }
    return undefined;
  }, [clientByIdRes]);

  // 3. Get Partner List
  const { data: partnerRes, isLoading: partnersLoading } = useQuery(['getAll', 'partner'], api.partner.getAll);

  const partnerList:{value: number, label: string}[] = React.useMemo(() => {
    const resData = partnerRes?.data?.data;
    if (resData) {
      return resData.map((partner) => ({
        value: partner.id,
        label: partner.name,
      }));
    }
    return [];
  }, [partnerRes]);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Update Partner Client
  * The logic is update partner client data from update client API,
  * we did this, because we still dont have API to update only partner
  * client
  */
  const { isLoading: updateLoading, mutate: handleUpdate } = useMutation(api.clients.update, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log('update result', res);
      alert('success');
      onNavigateToClientDetail();
    },
    onError: (err: Error) => {
      console.log('err', err.message);
      alert('error');
    },
  });
  const yupSchema = yup.object({
    partnerId: yup.string().required(yupErrorMsg.PARTNER_EMPTY),
    partnerCommission: yup.number().min(0, yupErrorMsg.COMMISION_POSITIVE).required(yupErrorMsg.COMMISION_EMPTY),
  });

  const currentFormik = useFormik({
    initialValues: {
      partnerId: '',
      partnerCommission: 0,
    },
    validationSchema: yupSchema,
    onSubmit: (values) => {
      if (clientById) {
        handleUpdate({
          ...clientById,
          partnerId: parseInt(values.partnerId, 10),
          partnerCommission: values.partnerCommission,
        });
      }
    },
  });

  const formik = React.useMemo(() => formikClient ?? currentFormik, [currentFormik, formikClient]);

  // Get partner data from ClientById
  React.useEffect(() => {
    if (clientById) {
      formik.setFieldValue('partnerId', partnerId ?? clientPartnerId ?? '');
      formik.setFieldValue('partnerCommission', clientById.partnerCommission ?? 0);
    }
  }, [clientById]);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Mode Form Changer
  * 1. setting mode into percentage
  * 2. setting mode into dollar fix price
  */
  const [currentMode, setCurrentMode] = React.useState<1 | 2>(1);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  return {
    clientId,
    partnerId,
    currentMode,
    setCurrentMode,
    partnerList,
    partnersLoading,
    formik,
    onCancelNavigate,
    clientById,
    updateLoading,
  };
}

export default useClientsAddPartner;
